import { useEffect } from "react";
import { useSystemMessage } from "../../../providers/SystemMessageContext";
import { useParams } from "react-router-dom";
import LoadingTakeover from "../../buffers/LoadingTakeover";

import { useGetExamComponentBaseQuery } from "../../../api";
import { examComponentBase, userData } from "../../../types";
import ExamComponentInfoTile from "../../widgets/ExamComponentInfoTile";
import withUser from "../../../wrappers/withUser";
import { Typography } from "@mui/material";
import "./index.scss";


const ExamComponentCatalog = ({userData}:{userData:userData}) => {
    const { showMessage } = useSystemMessage();
    const { exam_base_id } = useParams<{ exam_base_id:string }>();
    const { data, loading, error } = useGetExamComponentBaseQuery(null,exam_base_id);
    // useEffect(() => {
    //     if (data) {
    //         showMessage(data.message, data.success ? "success" : "error");
    //     }
    // }, [data]);

    if (loading) {
        return (
            <LoadingTakeover />
        )
    } else if (data) {
        const examList = data.data.map((examComponentBase:examComponentBase) => {
            return <ExamComponentInfoTile key={examComponentBase.id} examComponentBase={examComponentBase} />
        });
        return (
            <div className="header">
                <Typography sx={{mb:1, color:'#054fb9', fontWeight:700, textAlign:'left'}} variant="h4">Components</Typography>
                {examList}
            </div>
        );
    };
};

export default withUser(ExamComponentCatalog);